import api from "../../../api";

export const requestGetFilter = (id) => api.get(`/admin/user-filters/${id}`);
